(() => {
  if (window.__moxieRecommendationsInit) return;
  window.__moxieRecommendationsInit = true;

  const sliderSelector = '.moxie-recommendations slider-component';

  function isDesktop() {
    return window.matchMedia('(min-width: 750px)').matches;
  }

  function getStep(slider) {
    const slides = Array.from(slider.querySelectorAll('[id^="Slide-"]')).filter((slide) => slide.offsetWidth > 0);
    if (slides.length < 2) return slides[0]?.offsetWidth || 0;
    return slides[1].offsetLeft - slides[0].offsetLeft;
  }

  function getSlides(slider) {
    return Array.from(slider.querySelectorAll('[id^="Slide-"]')).filter((slide) => slide.offsetWidth > 0);
  }

  function getCurrentIndex(slider, slides) {
    const currentLeft = slider.scrollLeft;
    let currentIndex = 0;

    slides.forEach((slide, index) => {
      if (slide.offsetLeft <= currentLeft + 4) {
        currentIndex = index;
      }
    });

    return currentIndex;
  }

  function updateButtons(component) {
    const slider = component.querySelector('[id^="Slider-"]');
    const prevButton = component.querySelector('button[name="previous"]');
    const nextButton = component.querySelector('button[name="next"]');
    if (!slider || !prevButton || !nextButton) return;

    if (!isDesktop()) {
      prevButton.disabled = true;
      nextButton.disabled = true;
      return;
    }

    const slides = getSlides(slider);
    const maxScroll = Math.max(0, slider.scrollWidth - slider.clientWidth);
    const current = slider.scrollLeft;
    const tolerance = 2;

    prevButton.disabled = current <= tolerance;
    nextButton.disabled = current >= maxScroll - tolerance || maxScroll === 0 || slides.length < 2;
  }

  function bindComponent(component) {
    if (component.dataset.moxieSliderBound === 'true') return;

    const slider = component.querySelector('[id^="Slider-"]');
    const prevButton = component.querySelector('button[name="previous"]');
    const nextButton = component.querySelector('button[name="next"]');

    if (!slider || !prevButton || !nextButton) return;

    const handleClick = (direction) => (event) => {
      if (!isDesktop()) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const slides = getSlides(slider);
      if (slides.length < 2) return;

      const currentIndex = getCurrentIndex(slider, slides);
      const targetIndex = Math.max(0, Math.min(slides.length - 1, currentIndex + direction));
      const targetSlide = slides[targetIndex];
      if (!targetSlide || targetIndex === currentIndex) return;

      slider.scrollTo({
        left: targetSlide.offsetLeft,
        behavior: 'smooth',
      });
    };

    prevButton.addEventListener('click', handleClick(-1), true);
    nextButton.addEventListener('click', handleClick(1), true);
    slider.addEventListener('scroll', () => updateButtons(component), { passive: true });
    window.addEventListener('resize', () => updateButtons(component));

    component.dataset.moxieSliderBound = 'true';
    updateButtons(component);
  }

  function initMoxieRecommendationSliders(root = document) {
    root.querySelectorAll(sliderSelector).forEach(bindComponent);
  }

  document.addEventListener('DOMContentLoaded', () => initMoxieRecommendationSliders());
  document.addEventListener('shopify:section:load', (event) => initMoxieRecommendationSliders(event.target));

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches?.(sliderSelector)) {
          bindComponent(node);
        } else {
          initMoxieRecommendationSliders(node);
        }
      });
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
